import { useSite } from '../context/SiteContext';
import { curriculum } from '../data/course';
import { asset, toBn } from '../lib/utils';
import { taka } from '../lib/price';
import { CheckIcon } from './Icons';

const pains = [
  'চাকরির বিজ্ঞাপনে লেখা থাকে “MS Excel-এ দক্ষতা আবশ্যক” — কিন্তু আত্মবিশ্বাস পান না?',
  'অফিসে Excel-এর ছোট একটা হিসাব করতে ক্যালকুলেটর আর ঘণ্টার পর ঘণ্টা সময় লাগে?',
  'হাজার লাইনের ডেটা থেকে একটা তথ্য খুঁজতে স্ক্রল করতে করতেই সময় চলে যায়?',
  'YouTube-এ ছাড়া ছাড়া ভিডিও দেখে শুরু করেন, কিন্তু কোথাও গিয়ে আটকে যান?',
];

const outcomes = [
  'SUM, IF, VLOOKUP-এর মতো ফর্মুলায় মিনিটেই হিসাব শেষ করবেন',
  'Salary Sheet, Result Sheet, Attendance Sheet নিজেই তৈরি করতে পারবেন',
  'Sort, Filter ও Conditional Formatting দিয়ে বড় ডেটা গুছিয়ে রাখতে পারবেন',
  'Chart ও Pivot Table দিয়ে ডেটাকে সুন্দর রিপোর্টে রূপ দিতে পারবেন',
  'ইন্টারভিউতে আত্মবিশ্বাসের সাথে বলতে পারবেন — “Excel পারি”',
];

export function StatsBar() {
  const { course } = useSite();
  const totalTopics = curriculum.reduce((n, c) => n + c.topics.length, 0);
  const stats = [
    { value: toBn(course.totalClasses), label: 'লাইভ ক্লাস' },
    { value: toBn(course.windowDays), label: 'দিনে কোর্স শেষ' },
    { value: `${toBn(totalTopics)}+`, label: 'দরকারি টপিক' },
    course.price != null && { value: taka(course.price), label: 'পুরো কোর্স ফি' },
  ].filter(Boolean);

  return (
    <section className="border-y border-slate-200 bg-white">
      <div className={`container-x grid grid-cols-2 divide-slate-200 py-6 md:divide-x ${stats.length === 4 ? 'md:grid-cols-4' : 'md:grid-cols-3'}`}>
        {stats.map((s) => (
          <div key={s.label} className="px-4 py-3 text-center">
            <div className="text-3xl font-bold text-word-500 sm:text-4xl">{s.value}</div>
            <div className="mt-1 text-slate-500">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default function WhyLearn() {
  return (
    <section className="py-20">
      <div className="container-x grid gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <span className="eyebrow bg-red-50 text-red-600">আপনার সমস্যা কি এগুলো?</span>
          <h2 className="section-title">MS Office না জানার কারণে পিছিয়ে পড়ছেন?</h2>
          <ul className="mt-8 space-y-4">
            {pains.map((p) => (
              <li key={p} className="flex gap-3 rounded-xl border border-red-100 bg-red-50/50 p-4">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-sm text-red-500">✕</span>
                <span className="text-slate-700">{p}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-2xl">
            <img
              src={asset('/images/dashboard.jpg')}
              alt="ল্যাপটপের স্ক্রিনে ডেটা রিপোর্ট ও চার্ট"
              className="h-48 w-full object-cover sm:h-56"
              loading="lazy"
            />
          </div>
          <div className="relative -mt-10 mx-3 rounded-2xl bg-white p-6 shadow-xl ring-1 ring-slate-900/5 sm:mx-6">
            <h3 className="text-xl font-bold text-slate-900">কোর্স শেষে আপনি যা পারবেন</h3>
            <ul className="mt-4 space-y-3">
              {outcomes.map((o) => (
                <li key={o} className="flex gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-excel-100">
                    <CheckIcon className="h-4 w-4 text-excel-600" />
                  </span>
                  <span className="text-slate-700">{o}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
